import { computed, readonly } from 'vue';
import { getValueFromTogglerCookie, setCookieToggler } from '~/utils/toggler';

export const useTogglerRowOrCard = () => {
  // Реактивное значение из куки
  // Используем useState для глобального состояния, которое синхронизируется между компонентами
  const togglerState = useState<string>('toggler-row-or-card', ()  => {
    // При инициализации читаем значение из куки или используем значение по умолчанию
      const cookieValue = getValueFromTogglerCookie();
      if (cookieValue) {
        return cookieValue;
      }
      // Если кука не установлена, устанавливаем значение по умолчанию
      setCookieToggler('row');
      return 'row';
  });

  // Установить значение переключателя и обновить куку (кука обновляется через утилиту)
  const setTogglerState = (value: 'row' | 'card') => {
    if (togglerState.value === value) {
      return;
    }
    togglerState.value = value;
    setCookieToggler(value);
  };

  // компьютед карточек
  const isCardView = computed(() => togglerState.value === 'card');

  // компьютед строк
  const isRowView = computed(() => togglerState.value === 'row');

  return {
    togglerState: readonly(togglerState),
    setTogglerState,
    isCardView,
    isRowView,
  };
};

